/** CRT-01 — draft / certified / superseded transcript record status */

export const TRANSCRIPT_STATUS = {
  DRAFT: 'draft',
  CERTIFIED: 'certified',
  SUPERSEDED: 'superseded',
};

export const DRAFT_EXPORT_NOTICE =
  'DRAFT — NOT FOR OFFICIAL USE. This transcript has not been human-certified.';

export const normalizeTranscriptStatus = (item) => {
  if (!item) return TRANSCRIPT_STATUS.DRAFT;

  const explicit =
    item.transcript_status ||
    item.certification_status ||
    item.record_status ||
    item.metadata?.transcript_status;

  if (
    explicit === 'superseded' ||
    explicit === TRANSCRIPT_STATUS.SUPERSEDED ||
    item.is_superseded === true
  ) {
    return TRANSCRIPT_STATUS.SUPERSEDED;
  }

  if (
    item.is_certified === true ||
    item.certified_at ||
    explicit === 'certified' ||
    explicit === TRANSCRIPT_STATUS.CERTIFIED
  ) {
    return TRANSCRIPT_STATUS.CERTIFIED;
  }

  // RGN language versions always start as draft until independently certified
  const isRegenerated =
    item.is_regenerated ||
    item.regeneration_language ||
    item.parent_transcription_id ||
    item.metadata?.is_regenerated;

  if (isRegenerated && explicit !== TRANSCRIPT_STATUS.CERTIFIED) {
    return TRANSCRIPT_STATUS.DRAFT;
  }

  if (explicit === 'draft' || explicit === TRANSCRIPT_STATUS.DRAFT) {
    return TRANSCRIPT_STATUS.DRAFT;
  }

  return TRANSCRIPT_STATUS.DRAFT;
};

export const isTranscriptCertified = (transcription) =>
  normalizeTranscriptStatus(transcription) === TRANSCRIPT_STATUS.CERTIFIED;

export const isTranscriptLocked = (transcription) => isTranscriptCertified(transcription);

export const getTranscriptStatusLabel = (statusOrItem) => {
  const status =
    typeof statusOrItem === 'string'
      ? normalizeTranscriptStatus({ transcript_status: statusOrItem })
      : normalizeTranscriptStatus(statusOrItem);

  if (status === TRANSCRIPT_STATUS.CERTIFIED) return 'Certified';
  if (status === TRANSCRIPT_STATUS.SUPERSEDED) return 'Superseded';
  return 'Draft';
};

export const prependDraftNotice = (content, transcription) => {
  if (!content || isTranscriptCertified(transcription)) return content;
  return `${DRAFT_EXPORT_NOTICE}\n\n${content}`;
};

export const parseCertificationMeta = (item) => ({
  certified_at: item?.certified_at || item?.metadata?.certified_at || null,
  certified_by: item?.certified_by_name || item?.certified_by || item?.metadata?.certified_by || '',
  certifying_role: item?.certifying_role || item?.metadata?.certifying_role || '',
  draft_version_ref: item?.draft_version_ref || item?.metadata?.draft_version_ref || null,
  is_regenerated: Boolean(
    item?.is_regenerated ||
      item?.regeneration_language ||
      item?.parent_transcription_id ||
      item?.metadata?.is_regenerated
  ),
});
